import React from 'react'

// Types
import { RouteProps } from '../modules/navigation/types'

// Hooks
import { useTranslation } from 'react-i18next'

// Components
import { Layout } from '../layout'
import { Authenticate } from 'auth'

const CommentRoute: React.FC<RouteProps> = () => {

  const { t } = useTranslation()

  return (
    <Layout>
      <Authenticate>
        <h2>Comment</h2>
      </Authenticate>
    </Layout>
  )

}

export default CommentRoute